import React from "react";
import logo from "./logo.svg";
import "./delete_account_success.css";
import "./App.css";
import { useTranslation } from "react-i18next";

function DeleteAccountSuccess() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: 1,
          padding: "20px",
        }}
      >
        <p className="main-font-color">{t("account_delete_success")}</p>
      </div>
    </div>
  );
}

export default DeleteAccountSuccess;
